<template>
<div>
  <nav class="navbar navbar-expand navbar-dark bg-dark">
    <div class="container">
      <a class="navbar-brand" id="nav-principal" href="http://www.apa-pablo-picasso.es">AMPA Pablo Picasso</a>
    </div>
  </nav>

  <div class="container py-3" id="contenido">

    <div class="row justify-content-center">
      <div class="col-md-4 col-12">
        <div class="card mt-5">
          <h5 class="card-header">Acceso usuarios</h5>
          <div class="card-body">

            <form class="form-horizontal" id="login" action="" @submit.stop.prevent="enviarLogin" novalidate>

              <div class="form-group row">
                <label class="col-5 col-form-label" for="nif">NIF</label>
                <div class="col-7">
                  <input id="nif" name="nif" v-model="nif" type="text" class="form-control" :class="validarCampo(validarNIF(nif))" required>
                  <div class="invalid-feedback">Introduce un NIF o NIE válido</div>
                </div>
              </div>

              <div class="form-group row">
                <label class="col-5 col-form-label" for="password">Contraseña</label>
                <div class="col-7">
                  <input id="password" name="password" v-model="password" type="password" class="form-control">
                </div>
              </div>

              <p class="text-center"><button type="submit" class="btn btn-primary">Entrar</button></p>
              <p class="text-center"><router-link to="/acceso/restablecer"><button type="button" id="resetear-password" class="btn btn-primary">Restablecer contraseña</button></router-link></p>

              <div id="error-login">{{ this.mensaje_error }}</div>

            </form>

          </div>
        </div>
      </div>

      <div class="col-md-4 col-12">
        <div class="card mt-5">
          <h5 class="card-header">Inscripción de socios</h5>
          <div class="card-body">

            <p class="text-center mb-0"><router-link to="/inscripcion" class="btn btn-primary" role="button">Nuevo socio</router-link></p>

          </div>
        </div>
      </div>

    </div>
  </div>
</div>

</template>


<script>

import { api, login, obtenerSesion } from '../api/api.js';
//import { validarNIF } from '../validacion.js';

export default {
	name: 'Login',
	data() {
		return {
			nif: null,
			password: '',
			mensaje_error: '',
			validado: false,
		}
	},
	beforeCreate () {
		const sesion = obtenerSesion();
		if (sesion) {
			// FIXME: podría entrar en un loop porque aquí comprobamos sesión pero en otro
			// sitio se comprueba el token...
			//this.$router.push('/');
		}
	},
	methods: {
		//validarNIF,
		validarNIF() {
			// Deshabilito la comprobación porque hay gente que entra con pasaporte
			return true;
		},
		validarCampo(condicion) {
			if (! this.validado) {
				return '';
			}
			if (condicion) {
				return 'is-valid';
			} else {
				return 'is-invalid';
			}
		},
		enviarLogin() {
			if (! this.validarNIF(this.nif)) {
				this.validado = true;
				return;
			}
			this.validado = false;
			const data = {
				'nif': this.nif,
				'password': this.password,
			}
			api('/acceso/login', 'POST', data)
				.then((data) => {
					if (data.resultado) {
						login(data.resultado.token);
					} else {
						this.mensaje_error = data.error;
					}
				}
			);
		},
	}
}
</script>
